import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/**
 * Owner-scoped audit trail for an envelope. Server returns
 * `{ events, total, limit, offset }`; the timeline can grow long once the
 * ledger seam is live so callers pass `limit` + `offset` to paginate.
 * Default page is 100.
 */
export function useEnvelopeEvents(
  envelopeId: string | null | undefined,
  options: { limit?: number; offset?: number } = {},
) {
  const filterKey = { limit: options.limit ?? null, offset: options.offset ?? null };
  return useQuery({
    queryKey: [...queryKeys.documentSign.events(envelopeId ?? '__none__'), filterKey] as const,
    queryFn: () => api.listDocumentSignEvents(envelopeId as string, options),
    enabled: !!envelopeId,
    placeholderData: (prev) => prev,
  });
}
